import { api } from 'services/repositories/config/base-api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function makePaymentV1(data: any) {
  const response = await api.post('/api/v1/payment', data);

  return response.data;
}
